
import Gutter from '@/ui-kit/components/gutter';
import Typography from '@/ui-kit/components/typography';
import ExternalLink from '@/ui-kit/components/external-link';
import { TypographyType } from '@/ui-kit/components/typography/enums';
import {
  StyleColorSchemeType,
  StylePositionType,
  StyleSizeType,
  StyleFontWeightType,
} from '@/ui-kit/styles/enums';
import { ListingPageEvent } from '@/constants/AnalyticEvents';
import { ListingSummaryTitle } from './enums';

export default {
  name: 'ListingSummaryFeature',
  components: {
    Typography,
    Gutter,
    ExternalLink,
  },
  props: {
    title: {
      required: true,
      type: String,
    },
    link: {
      default: '',
      type: String,
    },
    value: {
      required: true,
      type: [String, Number],
    },
    analyticsOrigin: {
      default: '',
      type: String,
    },
  },
  data() {
    return {
      StyleSizeType,
      StylePositionType,
      StyleColorSchemeType,
      StyleFontWeightType,
      TypographyType,
    };
  },
  methods: {
    trackEvent() {
      const { id: listingId } = this.$route.params;
      const trackConfig = {
        [ListingSummaryTitle.Community]: ListingPageEvent.CommunityLink,
      };

      if (trackConfig[this.title]) {
        this.$track(`${this.analyticsOrigin}_${trackConfig[this.title]}`, { listingId });
      }
    },
  },
};
